module.exports = __webpack_public_path__ + "img/profit_bg_top.6551f5f9.png";